import { render, staticRenderFns } from "./PosAddPromotionNew.vue?vue&type=template&id=791c443b&scoped=true&"
import script from "./PosAddPromotionNew.vue?vue&type=script&lang=js&"
export * from "./PosAddPromotionNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791c443b",
  null
  
)

export default component.exports